import { defineComponent as _defineComponent } from 'vue'
import { Resource } from '~/types/resource';
import TLinkButton from '~/components/atoms/t-link-button.vue';
import Card from '~/components/card/Card.vue';

interface Props {
  blogs: Resource[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PinnedBlogs',
  props: {
    blogs: null
  },
  setup(__props: any) {



return { __sfc: true,TLinkButton, Card }
}

})